import { useQuery } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";
import { apiFetch } from "@core/index";

export type OverviewDashboardResponse = {
  lastPushAt: string;
  totalPushes: number;
  firstUpdatePostPush: string;
  lastUpdatePostPush: string;
  publishersUpdateCount: number;
  invoicePartiesUpdateCount: number;
  partnerChannelsUpdateCount: number;
  partnersUpdateCount: number;
  totalUpdateCount: number;
};

export const useGetOverviewDashboard = () => {
  return useQuery<OverviewDashboardResponse, Error>({
    queryKey: ["dashboardOverview"],
    queryFn: async () => {
      const url = `${apiEndpoint}/overview`;

      try {
        const data = await apiFetch<OverviewDashboardResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the dashboard overview data.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },
    placeholderData: (prev) => prev,
  });
};
